import styled from '@emotion/styled'

export const Label = styled.label`
  font-weight: 500;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #4a4a68;
`
